export const VALIDATION_REGEX = {
  /*   Checks if email is empty string or string which consists of 3 character sets that not includes whitespaces or @ symbol. First and second parts should be separated with @ symbol, second and third should be separated with . symbol.
  Examples of matching emails: name.surname@mail.com , example@test.com */
  email: /(^$)|(^[^\s@]+@[^\s@]+\.[^\s@]+$)/,
};

export const ERROR_MESSAGES = {
  email: 'Please enter a valid email address. Example: example@test.com',
};
